module.exports = __webpack_public_path__ + "static/media/ken-office.92d805ca.jpg";